<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" @search-change-event="searchChangeEvent($event)" @to-reset="toReset"></wt-form-table>
  </div>
</template>

<script>

export default {
  name: 'WarningRecord',
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_WARNINGRECORD',
        formComponent: {
          view: { type: 'component', componentName: 'WarningRecordViewPage', noRequest: true },
          list: { type: 'default', value: '/modules/warn/warnIntegralList' }
        },
        formInputsData: [
          { name: '社区', key: 'communityId', value: '', type: 'select', data: [] },
          { name: '站点', key: 'siteId', value: '', type: 'select', data: [] },
          { name: '时间', key: 'siteTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/warn/warnIntegralListImport',
          fileName: '预警记录',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '站点', key: 'siteName', type: 'text' },
          { name: '发放积分', key: 'giveIntegral', type: 'text' },
          { name: '出库积分', key: 'getIntegral', type: 'text' },
          { name: '差额', key: 'dvIntegral', type: 'text' },
          { name: '比例', key: 'dvPercent', type: 'text' },
          { name: '时间段', key: 'time', type: 'text' }], // 预警状态 1待处理/2已延迟3/已解决
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.queryCommunityNoPageList()
  },
  methods: {
    onButtonAction() {},
    toClickAction(row, type) {},
    searchChangeEvent(e) {
      if (e.key === 'communityId') {
        if (this.form.formInputsData[0].value) {
          this.form.formInputsData[1].value = ''
          this.communityIdChange()
        }
        if (!this.form.formInputsData[0].value) {
          this.form.formInputsData[1].value = ''
          this.form.formInputsData[1].data = []
        }
      }
    },
    toReset() {
      this.form.formInputsData[1].data = []
    },
    queryCommunityNoPageList() {
      this.$store.dispatch('queryCommunityNoPageList').then(res => {
        this.form.formInputsData[0].data = res
      })
    },
    communityIdChange() {
      this.$store.dispatch('querySiteListNoPageList', this.form.formInputsData[0].value).then(res => {
        this.form.formInputsData[1].data = res
      })
    }
  }
}
</script>

<style>
</style>
